import {
  defaultCreatorGrants,
  type GrantEntry,
  type RoleOption,
} from "../../shared/rbac/roles";
import {
  roleDefaultsForSpace,
  type SpaceGrant,
  type SpacePrincipalRoles,
  strongestSpaceGrants,
} from "./spaceSupplierGrants";

// space_uses_networks gates only on space:write, so only a space's editors (not
// its viewers or managers) need a network grant; the creator gets full access.
export function networkGrantsForSpace(
  spaceGrants: readonly SpaceGrant[],
  currentUserId?: string
): GrantEntry[] {
  const grants: GrantEntry[] = [];
  for (const { principal } of strongestSpaceGrants(
    spaceGrants,
    "space_uses_networks"
  )) {
    if (
      currentUserId &&
      "userId" in principal &&
      principal.userId === currentUserId
    )
      continue;
    grants.push({ ...principal, builtinRoleId: "network_user" });
  }
  if (currentUserId)
    grants.push(...defaultCreatorGrants("network", { userId: currentUserId }));
  return grants;
}

export function networkRoleDefaultsForSpace(
  spaceGrants: readonly SpaceGrant[],
  roleOptions: readonly RoleOption[]
): SpacePrincipalRoles {
  return roleDefaultsForSpace(networkGrantsForSpace(spaceGrants), roleOptions);
}
